import { ButtonProps as AntdButtonProps } from 'antd';
import { KccButtonType } from './KccButton.types';

export const TYPE_TO_ANTD_TYPE: Record<KccButtonType, AntdButtonProps['type']> = {
  primary: 'primary',
  secondary: 'default',
  tertiary: 'default',
  marketingCta: 'primary',
  link: 'link',
  dashed: 'dashed',
};
